/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation createWorkspaceMutation($record: WorkspaceCreateInput!) {
        createWorkspace(record: $record) {
            id
        }
    }
`;
